import PlotlySeriesMapperBase from './PlotlySeriesMapperBase.js';
import { SeriesDimension } from '../../enums/index.js';

/**
 * @see https://plotly.com/javascript/reference/scatter
 */
class PlotlyPolarSeriesMapper extends PlotlySeriesMapperBase {
    constructor(silent, fallback, traceTemplate) {
        super(silent, fallback, traceTemplate, 2);

        // https://plotly.com/javascript/reference/scatterpolar/#scatterpolar-r
        this.defineDimensionsMapping(SeriesDimension.X, 'r');
        // https://plotly.com/javascript/reference/scatterpolar/#scatterpolar-theta
        this.defineDimensionsMapping(SeriesDimension.Y, 'theta');
    }
}

export default PlotlyPolarSeriesMapper;